import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import ContractStatus from './ContractStatus';
import { computed } from "vue";
export default {
  __name: 'ContractBaseInfo',
  props: {
    contract: {
      type: Object
    }
  },
  setup(__props) {
    const props = __props;
    const contractType = computed(() => {
      switch (props.contract.contractType) {
        case 0:
          return '广告投放';
        case 1:
          return '活动宣传';
        case 2:
          return '媒介监测';
        default:
          return '未设置';
      }
    });
    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_descriptions, {
        title: "基本信息"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
          label: "合同编号"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.contractCode), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "合同名称"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.contractName), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "合同类型"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(contractType.value), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "供应商"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.supplier), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "合同生效时间"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.startDate), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "合同失效时间"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.endDate), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "合同金额"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.contractAmount), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "已用金额"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.usedAmount), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "剩余金额"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.contract.residueAmount), 1)]),
          _: 1
        }), _createVNode(_component_el_descriptions_item, {
          label: "合同清单状态"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ContractStatus), {
            "settlement-state": __props.contract.settlementState
          }, null, 8, ["settlement-state"])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};